import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { Releve } from '../account_model'
import TableOp from './TableOp'
import ListOp from './ListOp'
import { ContractsModel } from '../../../../../types/contracts/contractsModel'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	opNoResult: {
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center',
		padding: '5% 0px'
	},

	iconPdf: {
		fill: theme.palette.accessibility.main
	}

}))

interface AcceptingProps {
	releves: Array<Releve>,
	isLargeScreen: boolean,
	setOpenPayment: (amount: number, facture: string, piece_numero: string) => void,
	contract: ContractsModel,
	paymentDisabled: boolean
}

type AccountListProps = AcceptingProps

const AccountList: React.FC<AccountListProps> = (
	{
		releves,
		isLargeScreen,
		setOpenPayment,
		contract,
		paymentDisabled
	}
) => {
	const classes = useStyle()

	const opNoResult = classNames(
		isLargeScreen ? classes.title4 : classes.title5,
		classes.colorBlue,
		classes.opNoResult
	)

	//Check if docs is empty
	const isRelevesEmpty = (statements: Array<Releve>) => {
		return statements.length <= 0
	}

	return (
		<div>
			{isRelevesEmpty(releves) ?
				<span className={opNoResult}>
	                <FormattedMessage
		                id="contracts.account.emptyOp"
		                defaultMessage="Aucune opération à afficher"
		                description="Operation empty message"
	                />
				</span>
				:
				isLargeScreen ?
					<TableOp releves={releves} setOpenPayment={setOpenPayment} paymentDisabled={paymentDisabled}/>
					:
					<ListOp releves={releves} setOpenPayment={setOpenPayment} paymentDisabled={paymentDisabled} />
			}
		</div>
	)
}

export default AccountList
